import { render, staticRenderFns } from "./ChatReplyMessage.vue?vue&type=template&id=1a5da214&scoped=true&lang=pug"
import script from "./ChatReplyMessage.vue?vue&type=script&lang=js"
export * from "./ChatReplyMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatReplyMessage.vue?vue&type=style&index=0&id=1a5da214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5da214",
  null
  
)

export default component.exports